import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import LearnerPortfolioStudentList from "./routes/LearnerPortfolioStudentList";
export default store => {
  return {
    path: "learner-portfolio",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import("./components"),
          import("Post/modules/PostModule"),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const post = importedModule1.default;
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [LearnerPortfolioStudentList(store)],
  };
};
